<template>
    <div>
        <div class="title">
            <h4 class="mb-0">Transactions History</h4>
        </div>
        <div
            class="d-flex justify-content-end mb-3"
            v-if="_hasAccess('setting.subscription.add')"
        >
            <button
                type="button"
                class="btn"
                style="background-color: #e1e1e1; width: 120px"
                @click="editSubscriptionClick"
            >
                <spinner v-if="isLoadingEditModal" />
                <span v-else>Edit Subscription</span>
            </button>
        </div>
        <div>
            <LoaderList v-if="isLoading" class="w-100" />
            <div v-else class="table-responsive">
                <table class="table list">
                    <thead>
                        <tr>
                            <th>Date:</th>
                            <th>Description:</th>
                            <th v-if="isHasUserColumn">Users:</th>
                            <th>Fee:</th>
                            <th>Renews:</th>
                            <th>Promotion:</th>
                            <th>Confirmation:</th>
                        </tr>
                    </thead>
                    <tbody v-if="subscriptions && subscriptions.length">
                        <template
                            v-for="(subscription, index) in subscriptions"
                        >
                            <tr :key="'row-' + index">
                                <td>{{ getsubscriptionDate(subscription) }}</td>
                                <td>{{ subscription.description }}</td>
                                <td v-if="isHasUserColumn">
                                    {{ getUserQuota(subscription.user_quota) }}
                                </td>
                                <td>{{ subscription.fee }}</td>
                                <td>{{ subscription.type }}</td>
                                <td>{{ subscription.promotion_discount }}</td>
                                <td>{{ subscription.confirmation }}</td>
                            </tr>
                        </template>
                    </tbody>
                    <tbody v-else>
                        <tr>
                            <td :colspan="9">
                                <i>No records available</i>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>

            <div>
                <pagination
                    :current-page="filter.page"
                    :totalPages="totalPages"
                    :isLoading="isLoading"
                    @change-page="page => changePage(page)"
                />
            </div>
            <div>
                <ModalSubscriptionEdit
                    ref="ModalSubscriptionEdit"
                    @updateIsLoadingEditModal="updateIsLoadingEditModal"
                    @getSubscriptions="getSubscriptions"
                />
            </div>
        </div>
    </div>
</template>

<script>
import subscriptionService from "@/services/subscription";

export default {
    components: {
        LoaderList: () => import("@/components/elements/loader-list.vue"),
        Pagination: () => import("@/components/commons/pagination.vue"),
        Spinner: () => import("@/components/elements/spinner.vue"),
        ModalSubscriptionEdit: () =>
            import(
                "@/components/setting-subscription/subscription-edit/subscription-edit.vue"
            )
    },
    data() {
        return {
            isLoading: true,
            isLoadingEditModal: false,
            subscriptions: [],
            totalPages: 0,
            filter: {
                perPage: 20,
                page: 1
            }
        };
    },
    computed: {
        isHasUserColumn() {
            // NOTE: check if user_quota property is exist in subscription object
            if (
                this.subscriptions &&
                this.subscriptions.length &&
                this.subscriptions[0] &&
                Object.prototype.hasOwnProperty.call(
                    this.subscriptions[0],
                    "user_quota"
                )
            ) {
                return true;
            } else {
                return false;
            }
        }
    },
    created() {
        this.getSubscriptions();
    },
    methods: {
        getsubscriptionDate(subscription) {
            return this._carbonDateDisplay(subscription.date);
        },
        async getSubscriptions(page = null) {
            this.isLoading = true;

            if (page) {
                this.filter.page = page;
            }

            const response = await subscriptionService.getSubscriptions(
                this.filter
            );

            if (
                response.message &&
                response.message.code &&
                response.message.code == 200 &&
                response.message.response &&
                response.message.response.transaction &&
                response.message.response.transaction.data
            ) {
                this.subscriptions = response.message.response.transaction.data;
                this.totalPages =
                    response.message.response.transaction.last_page;
            }

            this.isLoading = false;
        },
        changePage(page) {
            this.filter.page = page;
        },
        editSubscriptionClick() {
            if (this.isLoadingEditModal) return;
            this.$refs.ModalSubscriptionEdit.open();
        },
        updateIsLoadingEditModal(isLoading) {
            this.isLoadingEditModal = isLoading;
        },
        getUserQuota(userQuota) {
            if (userQuota) {
                if (userQuota === -1) {
                    return "Unlimited";
                } else {
                    return userQuota;
                }
            } else {
                return "";
            }
        }
    },
    watch: {
        filter: {
            handler() {
                this.getSubscriptions();
            },
            deep: true
        }
    }
};
</script>

<style scoped></style>
